import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';
import users from '../../../../users';
import { validationMixin } from 'vuelidate';
import { required, minValue } from 'vuelidate/lib/validators';

export default {
  name: 'generatePropertyNumber',
  mixins: [users, validationMixin],
  components: {

  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1
    }
  },
  computed: {
    trimmedTownships: function () {
      return this.dataObj.townships.filter(t => t.group.id == this.dataObj.townId);
    }
  },
  validations: {
    dataObj: {
      //townId: {
      //  required
      //},
      appData: {
        townshipId: {
          required,
          minValue: minValue(1)
        },
        propertyRef: {
          required
        }
      }
    }
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('generate_customer_number_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.dataObj['townId'] = '';

        if (this.dataObj.appData.townships.length > 0 && this.dataObj.appData.townshipId) {
          this.dataObj.townId = this.dataObj.appData.townships.filter(t => t.value == this.dataObj.appData.townshipId)[0].group.id;
        }
      });
    },
    getValidationClass(obj1, obj2, obj3) {
      let field = null;

      if (obj3 == '')
        field = this.$v[obj1][obj2];
      else
        field = this.$v[obj1][obj2][obj3];

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    validateAppData() {
      //this.$v.dataObj.townId.$touch();
      this.$v.dataObj.appData.townshipId.$touch();

      if (!this.dataObj.refAutoGenerated)
        this.$v.dataObj.appData.propertyRef.$touch();

      if (this.dataObj.refAutoGenerated) {
        if (!this.$v.dataObj.appData.townshipId.$invalid) {
          return true;
        }
        else {
          return false;
        }
      }
      else {
        if (!this.$v.dataObj.appData.townshipId.$invalid && !this.$v.dataObj.appData.propertyRef.$invalid) {
          return true;
        }
        else {
          return false;
        }
      }
    },

    townSelected(val) {
      this.dataObj.appData.townshipId = null;
      this.dataObj.appData.propertyRef = null;
    },
    townshipSelected(val) {
      this.dataObj.appData.propertyRef = null;
    },
  },
}
